export default "__VITE_ASSET__542c2c9c__"